import { render, staticRenderFns } from "./AppArea.vue?vue&type=template&id=4bfe43b2&scoped=true&"
import script from "./AppArea.vue?vue&type=script&lang=ts&"
export * from "./AppArea.vue?vue&type=script&lang=ts&"
import style0 from "./AppArea.vue?vue&type=style&index=0&id=4bfe43b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe43b2",
  null
  
)

export default component.exports